export default __webpack_public_path__ + "static/media/KirstyTabletBlur.f90cc8ed.jpg";